module.exports = "<div class=\"gallery-loading-spinner\"></div>\r\n"